<template>
     <div :key="journal.ID" class="ml-0">
        <p class="text-subtitle-1 my-3 font-weight-medium font-weight-black">
            Issue: vol. {{ issue.v }} no. {{ issue.n }}, {{issue.y}}
            <router-link :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'all'}}" class="text-body-1 ml-5 my-3 font-weight-black">
            >> show all volumes </router-link>
        </p>
        <div v-for="(item,index) in articles" :key="index"  class="body-2 py-1">
            <p class="ma-0 pt-0 pb-1">{{ item.AUTHORS }}:</p>
            <p class="ma-0 pt-0 pb-1">
                <a :href="getHref(item.DOI)" class="text-decoration-underline pointer nb">{{ item.TITLE}}</a>
            </p>
            <p class="ma-0 pt-0 pb-1">
                 <span v-if="item.published != null"> Published online on<span v-html="item.published" class="px-1"></span>as </span>doi:
                <a :href="getHref(item.DOI)"  class="text-decoration-underline pointer nb">{{ item.DOI}}</a>
            </p>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {mapAction} from 'vuex';
import router from '../../../router';
export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            articles:null,
            number_to_bo_journal : {
                1 : "am.journal.bo",
                2 : "cmj.journal.bo",
                3 : "mb.journal.bo",
            },
        }
    },
    created() {
        this.getIssue();
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
            issue:'issue',
        })
    },
    methods: {
        ...mapActions('library',{
            setShowOneIssue:'setShowOneIssue',
        }),
        async getIssue(){
            try{
                const res = await axios.get('/index.php/api/library/journals/issue/'+this.$route.params.journal_id+'/'+this.issue.v+'/'+this.issue.n);
                if(res){
                    this.articles = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
         getHref(doi){
            return 'https://articles.math.cas.cz/'+doi;
        },
        getJournalRouteName() {
            if (this.bo) {
                let journal_name = this.number_to_bo_journal[parseInt(this.$route.params.journal_id)];
                if (journal_name) {
                    return journal_name;
                } else {
                    log.error("Could not translate number " + parseInt(this.$route.params.journal_id) + " into journal name");
                    // this will wrongly move the user to the non-bo page
                    return 'journal'; 
                }
            } else {
                return 'journal';
            }
        }
    },
}
</script>
<style scoped>
.nb{
    color:rgb(37,38,151) !important ;
}
</style>
